 
// export const useNumberFormatter = () => {
//   const formatNumberWithCommas = (value) => {
//     const num = Number(value);
//     if (isNaN(num)) return value || "";
//     return new Intl.NumberFormat("en-IN").format(num);
//   };

//   const onlyNumberKeyDown = (e) => {
//     if (
//       e.key === "Backspace" ||
//       e.key === "Delete" ||
//       e.key === "ArrowLeft" ||
//       e.key === "ArrowRight" ||
//       e.key === "Tab"
//     ) {
//       return;
//     }
//     if (!/[0-9]/.test(e.key)) {
//       e.preventDefault();
//     }
//   };

//   const handleNumberChange = (e, callback) => {
//     const raw = e.target.value.replace(/,/g, "");
//     callback(raw); // <-- pass raw number to parent
//   };

//   return {
//     formatNumberWithCommas,
//     onlyNumberKeyDown,
//     handleNumberChange,
//   };
// };


export const useNumberFormatter = () => {

  const formatNumberWithCommas = (value) => {
    if (!value && value !== 0) return "";

    // If it contains "/", split and format each part
    if (typeof value === "string" && value.includes("/")) {
      const parts = value.split("/");

      const formattedParts = parts.map((p) => {
        // Handle decimal in ratio parts
        if (p.includes(".")) {
          const [intPart, decPart] = p.split(".");
          const num = Number(intPart);
          if (isNaN(num)) return p;
          const formattedInt = new Intl.NumberFormat("en-IN").format(num);
          return decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
        }
        const num = Number(p);
        if (isNaN(num)) return p;
        return new Intl.NumberFormat("en-IN").format(num);
      });

      return formattedParts.join("/");
    }

    // Handle decimal numbers - preserve decimal input
    if (typeof value === "string" && value.includes(".")) {
      const [intPart, decPart] = value.split(".");
      const num = Number(intPart);
      if (isNaN(num)) return value;
      const formattedInt = new Intl.NumberFormat("en-IN").format(num);
      // Preserve the decimal part even if empty (user is typing)
      return decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
    }

    // Normal number formatting
    const num = Number(value);
    if (isNaN(num)) return value || "";

    return new Intl.NumberFormat("en-IN").format(num);
  };


  const onlyNumberKeyDown = (e) => {
    // Allow control keys
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Tab"
    ) {
      return;
    }

    // Allow slash for ratios
    if (e.key === "/") {
      return;
    }

    // Allow decimal point, but prevent multiple decimals
    if (e.key === ".") {
      const currentValue = e.target.value;
      // Don't allow if there's already a decimal point
      if (currentValue.includes(".")) {
        e.preventDefault();
      }
      return;
    }

    // Only allow digits
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };


  const handleNumberChange = (e, callback) => {
    // remove commas but keep slash
    const raw = e.target.value.replace(/,/g, "");
    callback(raw);
  };


  return {
    formatNumberWithCommas,
    onlyNumberKeyDown,
    handleNumberChange,
  };
};
